import { List, Create, Edit, View, DailyCash, DailyCashEntry, PreSanction, NoteSheet, JournalNoteSheet } from "../Components/index.js";

export default [
    {
        path: "/voucher/account/received",
        component: List,
        name: "account.voucher.received",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/account/received/create",
        component: Create,
        name: "account.voucher.received.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/account/received/:id/edit",
        component: Edit,
        name: "account.voucher.received.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/account/received/:id/view",
        component: View,
        name: "account.voucher.received.view",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/account/received/pre-sanction",
        component: PreSanction,
        name: "account.voucher.pre-sanction.received",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/account/received/:id/note-sheet",
        component: NoteSheet,
        name: "account.voucher.note-sheet",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/account/received/:id/journal-note-sheet",
        component: JournalNoteSheet,
        name: "account.voucher.journal-note-sheet",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/account/daily-cash",
        component: DailyCash,
        name: "voucher.account.daily.cash",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/account/daily-cash/create",
        component: DailyCashEntry,
        name: "voucher.account.daily.cash.create",
        meta: {
            requiresAuth: true,
        },
    },
];
